import styles from './Input.module.scss';

const Input = (props: {
    value: string;
    name: string;
    label?: string;
    placeholder?: string;
    maxLength?: number;
    handleChange?: any;
    handleKeyDown?: any;
    handleBlur?: any;
    onRenameConfirmedButtonClicked?: any;
}) => {
    return (
        <div className={styles.wrap} onBlur={props.handleBlur}>
            {props.label && <label htmlFor={props.name}>{props.label}</label>}
            <input
                name={props.name}
                value={props.value}
                onChange={props.handleChange}
                onKeyDown={props.handleKeyDown}
                autoFocus={true}
                maxLength={props.maxLength}
                placeholder={props.placeholder || ''}
                style={{
                    width: '100%',
                    maxHeight: '200px',
                    overflowY: 'auto',
                    resize: 'none',
                }}
            />
        </div>
    );
};

export default Input;
